import { styled, Theme } from '@mui/material';
import { Link } from 'react-router-dom';

import ActionButton from '@components/ActionButton';

export const sxStyles = {
  dialogWrap: {
    '.MuiPaper-root': {
      borderRadius: '12px',
    },
  },
  overallFitTitle: {
    marginTop: '0.125rem',
    marginLeft: '0.625rem',
  },
  infographicsWrap: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  infographicItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: '74px',
  },
  infographicTitle: (theme: Theme) => ({
    textAlign: 'center',
    marginBottom: '0.375rem',
    fontWeight: 700,
    color: theme.palette.primary.main,
  }),
  infographicValue: {
    display: 'flex',
    alignItems: 'center',

    '& > span:first-of-type': {
      marginLeft: '0.375rem',
    },
  },
  favoriteBtn: {
    height: '50px',
    width: '50%',
    transition: 'background-color 0.5s',
  },
  title: (theme: Theme) => ({
    padding: '1rem',
    borderBottom: `1px solid ${theme.palette.grey['300']}`,
  }),
  content: {
    padding: '1.5rem 3rem 1.5rem 1rem',
    marginTop: '1.5rem',
  },
};

export const StyledCareerCard = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '296px',
  backgroundColor: theme.palette.common.white,
  boxShadow: `0px 3px 14px 2px ${theme.palette.divider}`,
  borderTop: `5px solid ${theme.palette.primary.main}`,
  borderRadius: '0 0 4px 4px',
}));

export const StyledCareerPhoto = styled('div')(() => ({
  height: '184px',
  width: '100%',

  '& > img:first-of-type': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
}));

export const StyledOverallFitWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '0.5rem 1.25rem',
  minHeight: '40px',
  background: theme.palette.grey['100'],

  span: {
    marginRight: '0.25rem',
  },
}));

export const StyledCareerDetails = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  minHeight: '164px',
  padding: '1.5rem 1.25rem 0.75rem',

  '& > h4:first-of-type': {
    color: theme.palette.primary.main,
  },
}));

export const StyledActionsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  maxWidth: '256px',
  width: '100%',
  minHeight: '74px',
  margin: '0 1.25rem ',
  borderTop: `1px solid ${theme.palette.grey['300']}`,

  '&:before': {
    content: '""',
    position: 'absolute',
    height: '50px',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '1px',
    backgroundColor: theme.palette.grey['300'],
  },
}));

const StyledMore = ({ theme }: { theme: Theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '50px',
  width: '50%',
  fontWeight: 600,
  color: theme.palette.primary.main,
  transition: 'background-color 0.5s',

  '& > svg:first-of-type': {
    marginLeft: '1rem',
    fill: theme.palette.primary.main,
  },

  ':hover': {
    backgroundColor: '#EBF6F7',
  },
});

export const StyledMoreLink = styled('a')(({ theme }) => {
  return {
    ...StyledMore({ theme }),
  };
});

export const StyledMoreButton = styled(ActionButton)(({ theme }) => {
  return {
    ...StyledMore({ theme }),
    backgroundColor: theme.palette.common.white,
  };
});

export const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,

  '&:hover': {
    cursor: 'default',
  },
}));
